<div class="sx-menu">
  <ng-container *ngFor="let menuItem of menuItems; index as i">
    
    <div *ngIf="menuItem.itemType === itemTypeHeading" class="sx-menu-item sx-menu-item-heading sxl-flex sxl-row sxl-justify-between sxl-items-center" id="{{menuItem.id}}">
      <h5 [innerHtml]="menuItem.displayText"></h5>
      <span class="sx-menu-item__read-all" data-cy="menu-item-read-all" (click)="routeTo(allItemsUrl)">{{ allItemsText }}</span> 
    </div>

    <button mat-menu-item *ngIf="menuItem.itemType === itemTypeFunction" class="sx-menu-item sxl-flex sxl-row" id="{{menuItem.id}}" 
      (click)="callbackFunction( menuItem.callbackFunction )">
      <mat-icon class="sx-menu-item__icon" *ngIf="menuItem.iconName">
        <svg>
          <use [attr.xlink:href]="menuItem.iconName" [attr.href]="menuItem.iconName" />
        </svg>
      </mat-icon>
      <span>
        {{ menuItem.displayText }}
      </span>
    </button>

    <button mat-menu-item *ngIf="menuItem.itemType === itemTypeLink" class="sx-menu-item" id="{{menuItem.id}}"
      (click)="routeTo(menuItem.linkUrl)">
      <span [ngClass]="{'sx-menu-item-active': menuItem.active}" [innerHtml]="menuItem.displayText"></span>
    </button>

    <div mat-menu-item *ngIf="menuItem.itemType === itemTypeBlank" class="sx-menu-item sx-menu-item-blank sxl-flex sxl-row" id="{{menuItem.id}}">
      <mat-icon class="sx-menu-item__icon">
        <svg>
          <use [attr.xlink:href]="menuItem.iconName" [attr.href]="menuItem.iconName" />
        </svg>
      </mat-icon>
      <div class="sx-menu-item__text" [innerHtml]="menuItem.displayText"></div>
    </div>

    <div mat-menu-item class="sx-menu-item sx-menu-item__info-text sxl-flex sxl-justify-center" id="{{menuItem.id}}"
      *ngIf="menuItem.itemType === itemTypeInfoText" >
      {{ menuItem.displayText }}
    </div>
  </ng-container>
</div>
